import { render, staticRenderFns } from "./purchuseList.vue?vue&type=template&id=45e3f5dc&"
import script from "./purchuseList.vue?vue&type=script&lang=js&"
export * from "./purchuseList.vue?vue&type=script&lang=js&"
import style0 from "./purchuseList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports